import React from "react";
import { Boxes } from "lucide-react";

const CustomSourcing = () => {
  return (
    <section className="bg-white">
      <div className="container mx-auto px-4">
        {/* Banner Card with reduced scaling */}
        <div className="bg-primary rounded-[1rem] md:rounded-[2em] p-4 md:p-10 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 shadow-xl relative overflow-hidden group">
          <div className="absolute top-0 right-0 -mr-20 -mt-20 w-48 h-48 bg-accent/5 rounded-full blur-3xl"></div>

          {/* Smaller Icon container */}
          <div className="shrink-0 bg-white/5 p-4 rounded-2xl border border-white/10">
            <Boxes size={40} className="text-accent" />
          </div>

          {/* Scaled down typography */}
          <div className="text-center md:text-left relative z-10">
            <h2 className="text-xl md:text-3xl font-black text-white uppercase tracking-tight mb-2">
              Custom Sourcing & Bulk Packaging
            </h2>
            <p className="text-white/60 text-sm md:text-base font-medium max-w-xl leading-relaxed">
              We provide customized dehydrated solutions tailored to your
              industry standards.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomSourcing;
